<div class="visitor-chatbot-container" [ngStyle]="{
    top: '0',
    bottom: '0',
    zIndex: 1000004,
    position: 'fixed',
    right: translate.currentLang !== 'ar' ? '0' : null,
    left: translate.currentLang === 'ar' ? '0' : null
  }" [class.minimized]="isMinimized" [class.fullscreen]="isFullscreen" [class.rtl]="isRTL"
  [class.index-route]="isIndexPage" [class]="'size-' + config.size"
  [style.--primary-color]="appliedThemeColors.primaryColor" [style.--header-color]="appliedThemeColors.headerColor"
  [style.--button-color]="appliedThemeColors.buttonColor" [style.--background-color]="config.theme.backgroundColor">
  <mat-card class="chatbot-card">
    <!-- Header -->
    <div class="chatbot-header">
      <div class="header-left">
        <div class="header-text">
          <div class="title-container">
            <h3 style="color: #FFFFFF">{{ dynamicTitle || (config.title | translate) }}</h3>
            <span class="experimental-badge">{{ 'VISITOR_CHATBOT.EXPERIMENTAL' | translate }}</span>
          </div>
          <!-- Removed connection status - chatbot is always ready when opened -->
        </div>
      </div>

      <div class="header-actions">
        <button mat-icon-button class="action-btn" [matTooltip]="'VISITOR_CHATBOT.NEW_CHAT' | translate"
          (click)="newChat()">
          <mat-icon>add</mat-icon>
        </button>

        <button *ngIf="config.features.voiceSettings" mat-icon-button class="action-btn voice-settings-btn"
          [class.active]="isVoiceDialogOpen" [matTooltip]="
            (isVoiceDialogOpen
              ? 'VISITOR_CHATBOT.CLOSE_VOICE_SETTINGS'
              : 'VISITOR_CHATBOT.VOICE_SETTINGS'
            ) | translate
          " (click)="toggleVoiceSettingsDialog()">
          <mat-icon>settings_voice</mat-icon>
        </button>

        <!--        <select [(ngModel)]="selectedLang" class="language-select">-->
        <!--          <option value="ar-EG"> عربي </option>-->
        <!--          <option value="en-US"> English (US)</option>-->
        <!--        </select>-->

        <!--        <button-->
        <!--          *ngIf="config.features.voiceSettings"-->
        <!--          mat-icon-button-->
        <!--          class="action-btn"-->
        <!--          [ngClass]="{ 'listening': isVoiceDialogOpens }"-->
        <!--          [matTooltip]="-->
        <!--            (isVoiceDialogOpens-->
        <!--              ? 'VISITOR_CHATBOT.CLOSE_VOICE_SETTINGS'-->
        <!--              : 'VISITOR_CHATBOT.VOICE_SETTINGS'-->
        <!--            ) | translate-->
        <!--          "-->
        <!--          (click)="toggleVoiceSettings()"-->
        <!--        >-->
        <!--          <mat-icon>settings_voice</mat-icon>-->
        <!--        </button>-->

        <p *ngIf="recognizedText">📝 تم التعرف على: {{ recognizedText }}</p>
        <button *ngIf="config.features.fullscreen" mat-icon-button class="action-btn" [matTooltip]="
            (isFullscreen
              ? 'VISITOR_CHATBOT.EXIT_FULLSCREEN'
              : 'VISITOR_CHATBOT.FULLSCREEN'
            ) | translate
          " (click)="onFullscreen()">
          <mat-icon>{{
            isFullscreen ? "fullscreen_exit" : "fullscreen"
            }}</mat-icon>
        </button>

        <!-- Close button as the last button on the right side -->
        <button mat-icon-button class="action-btn" [matTooltip]="'VISITOR_CHATBOT.CLOSE' | translate"
          (click)="onClose()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <!-- Messages Container -->
    <div class="messages-container" #messagesContainer>
      <!-- Messages -->
      <div *ngFor="let message of messages" class="message" [class.user-message]="message.isUser"
        [class.bot-message]="!message.isUser" [class.system-message]="message.isSystem">
        <div class="message-content" [class.being-edited]="message.isEditing">
          <div class="message-header" *ngIf="message.icon">
            <mat-icon class="message-icon">{{ message.icon }}</mat-icon>
          </div>
          <div class="message-text" [class.with-icon]="message.icon" [innerHTML]="message.text"></div>

          <div class="message-footer">
            <small class="timestamp">
              {{ message.timestamp | date : "shortTime" }}
            </small>

            <!-- Message status indicator for user messages -->
            <div class="message-status" *ngIf="message.isUser">
              <mat-icon class="status-icon" [class.sent]="message.status === 'sent'"
                [class.delivered]="message.status === 'delivered'" [class.error]="message.status === 'error'">
                {{
                message.status === "sent"
                ? "done"
                : message.status === "delivered"
                ? "done_all"
                : message.status === "error"
                ? "error"
                : "schedule"
                }}
              </mat-icon>
            </div>

            <!-- Actions for bot messages -->
            <div class="message-actions" *ngIf="!message.isUser">
              <button *ngIf="config.features.textToSpeech" mat-icon-button class="action-icon-btn play-stop-btn"
                [class.playing]="message.isPlaying" [matTooltip]="
                  (message.isPlaying
                    ? 'VISITOR_CHATBOT.STOP_AUDIO'
                    : 'VISITOR_CHATBOT.PLAY_AUDIO'
                  ) | translate
                " (click)="togglePlayMessage(message)">
                <mat-icon>{{
                  message.isPlaying ? "stop" : "play_arrow"
                  }}</mat-icon>
              </button>

              <button *ngIf="config.features.copyMessages" mat-icon-button class="action-icon-btn"
                [matTooltip]="'VISITOR_CHATBOT.COPY_MESSAGE' | translate" (click)="copyMessage(message.text)">
                <mat-icon>content_copy</mat-icon>
              </button>
            </div>

            <!-- Edit action for the last user message -->
            <div class="message-actions user-actions" *ngIf="message.isUser && isLastUserMessage(message)">
              <button mat-icon-button class="action-icon-btn white edit-action" [class.active]="message.isEditing"
                [matTooltip]="'COMMON.EDIT' | translate" (click)="editUserMessage(message)">
                <mat-icon>edit</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Typing Indicator -->
      <div *ngIf="isTyping" class="message bot-message typing-indicator">
        <div class="message-content">
          <div class="message-header">
            <mat-icon class="message-icon">smart_toy</mat-icon>
          </div>
          <div class="typing-container">
            <div class="typing-text">
              {{ "VISITOR_CHATBOT.MESSAGES.TYPING" | translate }}
            </div>
            <div class="typing-dots">
              <span class="dot"></span>
              <span class="dot"></span>
              <span class="dot"></span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="isVoiceDialogOpens" class="inline-language-dialog">
      <mat-label>{{ 'COMMON.SELECT_LANGUAGE' | translate }}</mat-label>
      <mat-radio-group [(ngModel)]="selectedLang" name="languageSelection"
        style="display: flex; flex-direction: column; gap: 8px; margin-top: 8px;">
        <mat-radio-button value="ar-EG">عربي</mat-radio-button>
        <mat-radio-button value="en-US">English (US)</mat-radio-button>
      </mat-radio-group>
      <div class="dialog-actions">
        <button mat-button (click)="cancelLanguageSelection()">{{ 'COMMON.CANCEL' | translate }}</button>
        <button class="btn-color" mat-raised-button (click)="confirmLanguageSelection()">{{ 'COMMON.START' | translate
          }}</button>
      </div>
    </div>



    <!-- Input Section -->
    <div class="input-section" *ngIf="!isMinimized">
      <!-- Question Count Display -->
      <div class="question-count-display" *ngIf="!chatbotService.areLimitsDisabled() && questionCount > 0">
        <div class="count-info" [class.limit-warning]="questionCount >= 5"
          [class.limit-reached]="isQuestionLimitReached">
          <mat-icon>help_outline</mat-icon>
          <span *ngIf="!isQuestionLimitReached">{{ 'VISITOR_CHATBOT.QUESTIONS_USED' | translate:{ used: questionCount,
            total: maxQuestions } }}</span>
          <span *ngIf="isQuestionLimitReached" class="limit-text">{{ 'VISITOR_CHATBOT.QUESTION_LIMIT_REACHED' |
            translate }}</span>
        </div>
      </div>
      <!-- Simple textarea with inline send button -->
      <!--      <div class="textarea-wrapper">-->
      <!--  <textarea-->
      <!--    #messageTextarea-->
      <!--    [(ngModel)]="currentMessage"-->
      <!--    [placeholder]="config.placeholder | translate"-->
      <!--    (keydown)="onKeydown($event)"-->
      <!--    (input)="autoResizeTextarea()"-->
      <!--    (focus)="onInputFocus()"-->
      <!--    (blur)="onInputBlur()"-->
      <!--    class="simple-textarea"-->
      <!--    maxlength="1000"-->
      <!--    rows="4"-->
      <!--  ></textarea>-->

      <!--        <button-->
      <!--          mat-icon-button-->
      <!--          class="inline-send-btn"-->
      <!--          [matTooltip]="'VISITOR_CHATBOT.SEND_MESSAGE' | translate"-->
      <!--          [disabled]="!currentMessage.trim() || isTyping"-->
      <!--          color="primary"-->
      <!--          (click)="onSendButtonClick()"-->
      <!--        >-->

      <!-- Editing banner with cancel option -->
      <div class="edit-mode-banner" *ngIf="editingMessage">
        <mat-icon class="edit-mode-icon">edit</mat-icon>
        <span class="edit-mode-text">{{ 'VISITOR_CHATBOT.EDITING_MESSAGE' | translate }}</span>
        <button mat-icon-button class="edit-mode-cancel" (click)="cancelEditMessage()"
          [matTooltip]="'VISITOR_CHATBOT.CANCEL_EDIT' | translate">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="textarea-wrapper">
        <div class="textarea-container">
          <div class="input-resize-handle" (pointerdown)="startInputResize($event)"
            [matTooltip]="'VISITOR_CHATBOT.RESIZE_INPUT' | translate">
            <mat-icon>drag_handle</mat-icon>
          </div>
          <textarea #messageTextarea [(ngModel)]="currentMessage" [placeholder]="inputPlaceholder"
            [disabled]="isHikmaDisabled || (!chatbotService.areLimitsDisabled() && isQuestionLimitReached)"
            (keydown)="onKeydown($event)" (input)="autoResizeTextarea()" (focus)="onInputFocus()" (blur)="onInputBlur()"
            class="simple-textarea" [class.disabled]="isHikmaDisabled || isQuestionLimitReached" maxlength="1000"
            rows="6"></textarea>

          <div class="inline-input-actions">
            <!-- 🎤 زر الميكروفون داخل الصندوق -->
            <button *ngIf="config.features.voiceSettings" mat-icon-button class="inline-action-button voice-btn-inside"
              [ngClass]="{ 'listening': isRecording }" [disabled]="isHikmaDisabled" [matTooltip]="isHikmaDisabled ? ('AI_ASSISTANT.HIKMA_NOT_SUBSCRIBED_TOOLTIP' | translate) : (
          (isVoiceDialogOpens
            ? 'VISITOR_CHATBOT.CLOSE_VOICE_SETTINGS'
            : 'VISITOR_CHATBOT.VOICE_SETTINGS'
          ) | translate
        )" (click)="toggleVoiceSettings()">
              <mat-icon>settings_voice</mat-icon>
            </button>

            <!-- 📨 زر الإرسال -->
            <button mat-icon-button class="inline-action-button inline-send-btn"
              [matTooltip]="isHikmaDisabled ? ('AI_ASSISTANT.HIKMA_NOT_SUBSCRIBED_TOOLTIP' | translate) : ((!chatbotService.areLimitsDisabled() && isQuestionLimitReached) ? ('VISITOR_CHATBOT.QUESTION_LIMIT_REACHED' | translate) : ((editingMessage ? 'VISITOR_CHATBOT.UPDATE_MESSAGE' : 'VISITOR_CHATBOT.SEND_MESSAGE') | translate))"
              [disabled]="isHikmaDisabled || !currentMessage.trim() || isTyping || (!chatbotService.areLimitsDisabled() && isQuestionLimitReached)"
              color="primary" (click)="onSendButtonClick()">
              <mat-icon>{{ isHikmaDisabled ? "block" : ((!chatbotService.areLimitsDisabled() && isQuestionLimitReached)
                ?
                "block" : (isTyping ?
                "hourglass_empty" : (editingMessage ? "check" : "send"))) }}</mat-icon>
            </button>
          </div>
        </div>
      </div>


    </div>
  </mat-card>
</div>